import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  useRedirect,
  useNotify,
  useRecordContext,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import ResourceBreadcrumbsWithActions from '../../components/ResourceBreadcrumbsWithActions';

const RegionEditTitle = () => {
  const record = useRecordContext();
  if (!record) return 'Loading...';
  return `Edit: ${record.name}`;
};

export const RegionEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSuccess = () => {
    notify('Region updated successfully');
    redirect('/regions');
  };

  return (
    <Edit resource="regions" redirect={false} onSuccess={handleSuccess} title={<RegionEditTitle />}>
      <SimpleForm>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            Edit Region
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Update region information and settings
          </Typography>
        </Box>

        <TextInput
          source="name"
          label="Region Name"
          validate={[{ required: 'Region name is required' }]}
          fullWidth
        />

        <TextInput
          source="description"
          label="Description"
          multiline
          rows={3}
          fullWidth
        />

        <SelectInput
          source="brandId"
          label="Brand"
          optionText="name"
          optionValue="id"
          validate={[{ required: 'Brand is required' }]}
          fullWidth
        />

        <TextInput
          source="location"
          label="Location"
          placeholder="e.g., North America, Europe"
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
};
